import { useState } from "react";
import { MessageCircle, X, Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* WhatsApp Chat Widget */}
      {isOpen && (
        <Card className="fixed bottom-24 right-4 w-80 z-50 shadow-strong">
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-green-500 flex items-center justify-center">
                  <MessageCircle className="h-5 w-5 text-white" />
                </div>
                <div>
                  <CardTitle className="text-sm">Natcon Sacco Support</CardTitle>
                  <div className="flex items-center gap-1 text-xs text-green-600">
                    <div className="h-2 w-2 rounded-full bg-green-500"></div>
                    Online
                  </div>
                </div>
              </div>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => setIsOpen(false)}
                className="h-8 w-8 p-0"
                aria-label="Close chat window"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </CardHeader>
          <CardContent className="pt-0">
            <div className="space-y-3">
              <div className="bg-secondary/50 p-3 rounded-lg">
                <p className="text-sm text-foreground">
                  Hello! 👋 How can we help you today?
                </p>
              </div>
              
              <div className="space-y-2">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full justify-start text-xs"
                  onClick={() => window.open('https://wa.me/254111485951?text=I need help with loan application', '_blank')}
                >
                  💰 Loan Application Help
                </Button>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full justify-start text-xs"
                  onClick={() => window.open('https://wa.me/254111485951?text=I want to join Natcon Sacco', '_blank')}
                >
                  👥 Membership Enquiry
                </Button>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full justify-start text-xs"
                  onClick={() => window.open('https://wa.me/254111485951?text=I need account support', '_blank')}
                >
                  🏦 Account Support
                </Button>
              </div>

              <div className="flex items-center gap-2 text-xs text-muted-foreground pt-2 border-t">
                <Clock className="h-3 w-3" />
                <span>Available: Mon-Fri 8AM-5PM</span>
              </div>

              <Button 
                className="w-full bg-green-500 hover:bg-green-600 text-white"
                onClick={() => window.open('https://wa.me/254111485951', '_blank')}
              >
                <MessageCircle className="h-4 w-4 mr-2" />
                Start WhatsApp Chat
              </Button>
            </div>
          </CardContent>
        </Card>
      )}

      {/* WhatsApp Floating Button */}
      <Button
        className="fixed bottom-4 right-4 h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-strong z-40"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close WhatsApp chat" : "Open WhatsApp chat"}
      >
        {isOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <MessageCircle className="h-6 w-6" />
        )}
      </Button>
    </>
  );
};

export default WhatsAppWidget;